<template v-slot:searchAreaHeader>
  <div class="app-main-inner-row extension-conditions-form writeoff-search-areaheader">
    <el-form inline label-position="left">
      <el-form-item :label="$t('WriteOff.revenueAndExpenditureMethod')" class="el-form-item-search">
        <el-radio-group v-model="searchConditions.isAr" no="1" @change="isArChangeHandler">
          <el-radio :label="-1" :disabled="!searchConditions.allowWriteoffQueryAll">{{ $t('WriteOff.all') }}</el-radio>
          <el-radio v-show="writeOffPrivilegeAr" :label="1" :disabled="!searchConditions.rbArEnabled">{{ $t('WriteOff.receivables') }}</el-radio>
          <el-radio v-show="writeOffPrivilegeAp" :label="0" :disabled="!searchConditions.rbApEnabled">{{ $t('WriteOff.payables') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="showFeeTypeForm" :label="$t('WriteOff.feeType')" class="el-form-item-search">
        <el-radio-group v-model="searchConditions.isOversea" no="2">
          <!--按费用查询时费用类型增加全部选项-->
          <el-radio v-if="searchConditions.writeOffMode === 1" :label="-1">{{ $t('WriteOff.all') }}</el-radio>
          <el-radio :label="0">{{ $t('WriteOff.domestic') }}</el-radio>
          <el-radio :label="1">{{ $t('WriteOff.international') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$t('WriteOff.writeOffMode')" class="el-form-item-search">
        <el-radio-group v-model="searchConditions.writeOffMode" no="3">
          <el-radio v-show="writeOffPrivilegeCharge" :label="1">{{ $t('WriteOff.charges') }}</el-radio>
          <el-radio v-show="writeOffPrivilegeInvoice" :label="2">{{ $t('WriteOff.invoice') }}</el-radio>
          <el-radio v-show="writeOffPrivilegeBilling" :label="3">{{ $t('WriteOff.bill') }}</el-radio>
          <el-radio v-show="writeOffPrivilegeBillingGroup" :label="4">{{ $t('WriteOff.accountStatement') }}</el-radio>
          <el-radio v-show="writeOffPrivilegeBillPayment" :label="5">{{ $t('WriteOff.paymentRequest') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="useOrderCenterMode" label-width="0" class="el-form-item-search">
        <el-checkbox v-model="searchConditions.internalCharge" no="4">{{ $t('CargoMsg.Cargo_InternalCharges') }}</el-checkbox>
      </el-form-item>
      <el-form-item :label="$t('WriteOff.revenueAndExpenditureDate')" class="el-form-item-search">
        <el-date-picker
          v-model="searchConditions.rpDate"
          no="5"
          type="date"
          :clearable="false"
          value-format="yyyy-MM-dd"
          :editable="false"
        />
      </el-form-item>
      <el-form-item :label="inputDateLabel" class="el-form-item-search">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="0">
              <el-date-picker
                v-model="searchConditions.inputDateStart"
                type="date"
                no="6"
                style="margin-right: 0px;"
                :clearable="false"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :editable="false"
              /></el-form-item>
          </el-col>
          <el-col :span="2"><span>{{ $t('WriteOff.dateTo') }}</span></el-col>
          <el-col :span="8">
            <el-form-item label-width="0">
              <el-date-picker
                v-model="searchConditions.inputDateEnd"
                type="date"
                no="7"
                clearable
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="0">
              <el-checkbox v-model="allowTwoYearOutside" no="8">{{ $t('WriteOff.queryLotsOfData') }}</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import StrUtils from '@/utils/StrUtils'
import moment from 'moment'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'

export default {
  name: 'WriteoffSearchAreaHeader',
  props: {
    pageMode: { type: Number, default: 0 }, // 页面模式: 0-未销账列表 1-销账列表
    searchConditions: { type: Object, required: true },
    writeOffPrivilege: { type: Object, required: true }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: this.disabledDate
      },
      allowTwoYearOutside: false
      // writeOffPrivilege: {
      //   charge: false,
      //   invoice: false,
      //   billing: false,
      //   billingGroup: false,
      //   billPayment: false
      // }
    }
  },
  computed: {
    inputDateLabel() {
      switch (this.searchConditions.writeOffMode) {
        case 1: return this.$t('Invoice.invoice_businessDate')
          break
        case 2: return this.$t('Invoice.invoice_invoiceDate')
          break
        case 3:
        case 4: return this.$t('Billing.billingJob_billDate')
          break
        case 5: return this.$t('Billing.billingJob_billPaymentDate')
          break
      }
    },
    getConfirmMsg() {
      switch (this.searchConditions.writeOffMode) {
        case 1: return this.$t('Invoice.invoice_unlockBusinessDateQuery')
          break
        case 2: return this.$t('Invoice.invoice_unlockInvoiceDateQuery')
          break
        case 3:
        case 4: return this.$t('Billing.billingJob_unlockInputDateQuery')
          break
        case 5: return this.$t('Billing.billingJob_unlockBillPaymentDateQuery')
          break
      }
    },
    showFeeTypeForm() {
      return ![2, 5].includes(this.searchConditions.writeOffMode) && this.isShowFeeType()
    },
    writeOffPrivilegeCharge() {
      return (this.writeOffPrivilege.chargeAr && this.isAr) || (this.writeOffPrivilege.chargeAp && !this.isAr)
    },
    writeOffPrivilegeInvoice() {
      return (this.writeOffPrivilege.invoiceAr && this.isAr) || (this.writeOffPrivilege.invoiceAp && !this.isAr)
    },
    writeOffPrivilegeBilling() {
      return (this.writeOffPrivilege.billingAr && this.isAr) || (this.writeOffPrivilege.billingAp && !this.isAr)
    },
    writeOffPrivilegeBillingGroup() {
      return (this.writeOffPrivilege.billingGroupAr && this.isAr) || (this.writeOffPrivilege.billingGroupAp && !this.isAr)
    },
    writeOffPrivilegeBillPayment() {
      return this.writeOffPrivilege.billPayment && (this.searchConditions.isAr === 0 || this.searchConditions.isAr === -1)
    },
    writeOffPrivilegeAr() {
      return (this.writeOffPrivilege.chargeAr && this.searchConditions.writeOffMode === 1) || (this.writeOffPrivilege.invoiceAr && this.searchConditions.writeOffMode === 2) || (this.writeOffPrivilege.billingAr && this.searchConditions.writeOffMode === 3) || (this.writeOffPrivilege.billingGroupAr && this.searchConditions.writeOffMode === 4)
    },
    writeOffPrivilegeAp() {
      return (this.writeOffPrivilege.chargeAp && this.searchConditions.writeOffMode === 1) || (this.writeOffPrivilege.invoiceAp && this.searchConditions.writeOffMode === 2) || (this.writeOffPrivilege.billingAp && this.searchConditions.writeOffMode === 3) || (this.writeOffPrivilege.billingGroupAp && this.searchConditions.writeOffMode === 4) || (this.writeOffPrivilege.billPayment && this.searchConditions.writeOffMode === 5)
    },
    isAr() {
      return this.searchConditions.isAr !== 0
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
    allowTwoYearOutside(val) {
      if (val) {
        let msg = this.getConfirmMsg
        if (StrUtils.isEmpty(msg)) {
          msg = '若选的日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？'
        }
        this.$confirm(msg, this.$t('CargoMsg.Cargo_ConfirmR'), { type: 'warning' }).catch(err => {
          console.log(err)
          this.allowTwoYearOutside = false
        })
      } else {
        this.searchConditions.inputDateStart = moment().subtract(2, 'y').format('yyyy-MM-DD')
      }
    }
  },
  mounted() {
    this.refreshWriteOffPrivilege()
  },
  methods: {
    disabledDate(currDate) {
      if (!this.allowTwoYearOutside) {
        const beforeTwoYear = moment().subtract(2, 'y').subtract(1, 'days')
        return currDate < beforeTwoYear
      }
      return false
    },
    isArChangeHandler(value) {
      this.searchConditions.isAr = value
      if (this.searchConditions.isAr === 1 && this.searchConditions.writeOffMode === 5) {
        this.searchConditions.writeOffMode = 2
      }
      this.$nextTick(() => {
        this.refreshWriteOffPrivilege()
      })
    },
    isShowFeeType() {
      return this.writeOffPrivilegeCharge || this.writeOffPrivilegeBilling || this.writeOffPrivilegeBillingGroup
    },
    permission() {
      const isAr = this.isAr
      const charge = isAr ? this.writeOffPrivilege.chargeAr : this.writeOffPrivilege.chargeAp
      const invoice = isAr ? this.writeOffPrivilege.invoiceAr : this.writeOffPrivilege.invoiceAp
      const billing = isAr ? this.writeOffPrivilege.billingAr : this.writeOffPrivilege.billingAp
      const billingGroup = isAr ? this.writeOffPrivilege.billingGroupAr : this.writeOffPrivilege.billingGroupAp
      const billPayment = (isAr && !this.searchConditions.isAr) ? false : this.writeOffPrivilege.billPayment
      return [charge, invoice, billing, billingGroup, billPayment]
    },
    refreshWriteOffPrivilege() {
      const permission = this.permission()
      const writeOffMode = this.searchConditions.writeOffMode
      if (!permission[writeOffMode - 1]) {
        for (let key = 0; key < permission.length; key++) {
          if (permission[key]) {
            this.searchConditions.writeOffMode = key + 1
            return
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .writeoff-search-areaheader {
    .el-form-item-search {
      margin-right: 15px;
      .el-form-item__label {
        padding-right: 5px;
        font-size: 14px !important;
      }
      .el-form-item__content {
        .el-radio {
          margin-right: 3px;
          .el-radio__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-checkbox {
          .el-checkbox__label {
            font-size: 13px !important;
            padding-left: 2px;
          }
        }
        .el-date-editor {
          //.el-input__prefix {
          //  display: none;
          //}
        }
        .el-input {
          width: 110px;
        }
        .el-input__inner {
          padding-left: 20px !important;
          padding-right: 5px !important;
          width: 110px;
        }
      }
    }
  }
</style>
